/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

import "./utils/DocumentoUtil";

import Echo from "laravel-echo";
import { createApp } from "vue";
import SummernoteEditor from "vue3-summernote-editor";
import ignoredElements from "./configs/vue-ignored-elements";
import VueGoogleCharts from "vue3-googl-chart";
import Paginate from "vuejs-paginate-next";
import { createPinia } from "pinia";
import { vMaska } from "maska";
import router from "./router";

window.Echo = Echo;
window.slugify = require("./services/StringUtilService").slugify;

const pinia = createPinia();
/**
 * Instanciar Vue
 */
const vueApp = createApp({});
vueApp.use(pinia);
vueApp.config.compilerOptions.isCustomElement = (tag) =>
  ignoredElements.indexOf(tag) !== -1;

/** Base Components */
vueApp.component(
  "DatetimePicker",
  require("./components/DatetimePicker.vue").default
);
vueApp.component("Select2", require("./components/Select2.vue").default);
vueApp.component("VToggle", require("./components/VToggle.vue").default);
vueApp.component("SummernoteEditor", SummernoteEditor);
vueApp.component(
  "VariaveisTemplate",
  require("./components/VariaveisTemplate.vue").default
);
vueApp.use(VueGoogleCharts);
vueApp.use(Paginate);

/** Base Directives */
vueApp.directive("input-format", require("./directives/InputFormat").default);
vueApp.directive(
  "textarea-elastic",
  require("./directives/TextareaElastic").default
);
vueApp.directive(
  "floating-bottom",
  require("./directives/FloatingBottom").default
);
vueApp.directive("uppercase", require("./directives/Uppercase").default);
vueApp.directive("uncapitalize", require("./directives/Uncapitalize").default);
vueApp.directive("maska", vMaska);
/** Page Components */
vueApp.component(
  "vue-components",
  require("./components/VueComponents.vue").default
);

vueApp.component(
  "form-doar",
  require("./components/FormDoar/Doar.vue").default
);
vueApp.component(
  "form-cadastro",
  require("./components/FormCadastro/Cadastro.vue").default
);
vueApp.component(
  "form-campanha",
  require("./components/FormCampanha/Campanha.vue").default
);
vueApp.component(
  "dashboard-router",
  require("./components/Dashboard/DashboardRouter.vue").default
);

vueApp.use(router);

vueApp.mount("#vue-app");
